import React from 'react'
import {
  Button,
  TableRow,
  TableCell,
  Table,
  TableBody,
  withStyles
} from '@material-ui/core'
import { useForm, Form, Field } from '../../form'

const styles = (theme) => ({
  textField: {
    fontSize: '15px',
    marginTop: theme.spacing(4),
    width: '100%'
  },
  tableCell: {
    border: 'none',
    padding: '8px 10px'
  },
  select: {
    fontSize: '15px',
    padding: '4px',
    outline: 'none',
    marginBottom: '6px',
    cursor: 'pointer',
    border: '1px solid gray'
  }
})

class AdminIRForm extends React.Component {
  render() {
    return <AdminIRFormComponent {...this.props} />
  }
}

export default withStyles(styles)(AdminIRForm)

const defaultValues = {
  salaryId: '',
  firstname: '',
  start_date: null,
  end_date: null
}

const AdminIRFormComponent = ({ classes, adminsearchIRSalaryInfo }) => {
  const form = useForm({
    name: 'adminUpdates',
    onSubmit: onSubmit,
    defaultValues: defaultValues,
    resetOnSubmit: false
  })

  const { control, setValue } = form

  function onSubmit(values) {
    adminsearchIRSalaryInfo(values)
  }

  return (
    <Form {...form}>
      <Table>
        <TableBody>
          <TableRow>
            <TableCell className={classes.tableCell}>
              <Field
                name="salaryId"
                label="Palkkatunnus"
                inputType="textfield"
                control={control}
                className={classes.textField}
              />
            </TableCell>
            <TableCell className={classes.tableCell}>
              <Field
                name="firstname"
                label="Käyttäjänimi"
                inputType="textfield"
                control={control}
                className={classes.textField}
              />
            </TableCell>
            <TableCell className={classes.tableCell}>
              <Field
                name="start_date"
                inputType="datepicker"
                label="Alkupvm"
                control={control}
                className={classes.textField}
                clearable
                onClear={() => setValue('start_date', null)}
              />
            </TableCell>
            <TableCell className={classes.tableCell}>
              <Field
                name="end_date"
                inputType="datepicker"
                label="Loppupvm"
                control={control}
                className={classes.textField}
                clearable
                onClear={() => setValue('end_date', null)}
              />
            </TableCell>
            <TableCell className={classes.tableCell}>
              <Button
                className="pull-right"
                variant="contained"
                style={{ width: '80px' }}
                type="submit"
              >
                HAE
              </Button>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </Form>
  )
}
